// src/components/CommunityResourcesCard.tsx
import React from 'react';
import { 
  Card, Text, Title, Group, Button, Box, Badge
} from '@mantine/core';
import { 
  IconBrandFacebook, IconBrandReddit, IconUsers, IconLink, IconExternalLink
} from '@tabler/icons-react';
import { communityResources } from '../data';

const CommunityResourcesCard: React.FC = () => (
  <Card shadow="md" p="xl" radius="lg" withBorder className="modern-card resources-card">
    <Title order={3} mb="md" c="gray.1">Community & Support Resources</Title>
    <Text mb="xl" c="gray.3">
      Connecting with others who understand what you're going through can make a significant difference. 
      These online communities provide support, advice, and a sense of belonging.
    </Text>
    
    <Box className="resource-grid">
      {communityResources.map((resource, index) => (
        <Card 
          key={index} 
          withBorder 
          radius="md" 
          mb="lg" 
          p="md" 
          className="resource-item modern-card" 
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <Group justify="space-between" mb="md">
            <Badge 
              size="lg" 
              radius="md" 
              color={resource.type === 'facebook' ? 'blue' : resource.type === 'reddit' ? 'red' : 'gray'}
              leftSection={
                resource.type === 'facebook' ? <IconBrandFacebook size={14} /> : 
                resource.type === 'reddit' ? <IconBrandReddit size={14} /> : 
                <IconLink size={14} />
              }
            >
              {resource.type.charAt(0).toUpperCase() + resource.type.slice(1)}
            </Badge>
            <Text size="xs" c="dimmed">
              <Group gap={5}>
                <IconUsers size={14} />
                {resource.members}
              </Group>
            </Text>
          </Group>

          <Title order={4} mb="xs" c="gray.1">{resource.name}</Title>
          <Text size="sm" mb="md" c="gray.3">{resource.description}</Text>
          
          <Button 
            fullWidth
            variant="light" 
            color="indigo"
            radius="md"
            component="a" 
            href={resource.url} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Group gap="xs">
              <span>Link to community</span>
              <IconExternalLink size={16} />
            </Group>
          </Button>
        </Card>
      ))}
    </Box>
    
    <Text size="sm" mt="xl" c="dimmed" fs="italic">
      Note: Community sizes are approximate and may have changed. Each group may have their own rules 
      and membership requirements.
    </Text>
  </Card>
);

export default CommunityResourcesCard;